import { useState, useEffect } from 'react';
import { apiPost } from '@/lib/api-client';

interface CheckinResponse {
  checkinMessage: string;
  alreadyCheckedIn: boolean;
}

export function useCheckin() {
  const [checkin, setCheckin] = useState<CheckinResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function fetchCheckin() {
      try {
        setLoading(true);
        const data = await apiPost<CheckinResponse>('/api/daily-checkin');
        setCheckin(data);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to load check-in');
      } finally {
        setLoading(false);
      }
    }

    fetchCheckin();
  }, []);

  return { checkin, loading, error };
}
